module.exports = "<div id=\"dropZone\"  [className]=\"customstyle\" [class.over]=\"dragoverflag\" \r\n    (drop)=\"dropFiles($event)\" \r\n    (dragover)=\"onDragOver($event)\" (dragleave)=\"onDragLeave($event)\">\r\n    <div class=\"content\">\r\n        {{headertext}}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/file-drop.component.html
// module id = ../../../../ngx-file-drop/lib/ngx-drop/file-drop.component.html
// module chunks = 11